import env from '@beam-australia/react-env';

import { ENV_CONFIG_ATTRIBUTES } from 'app/config/env-config-attributes';

const config = {
    ENV: env(ENV_CONFIG_ATTRIBUTES.ENV),
    BASE_PATH: env(ENV_CONFIG_ATTRIBUTES.BASE_PATH),
    BE_BASE_PATH: env(ENV_CONFIG_ATTRIBUTES.BE_BASE_PATH),
    MY_PAGES_URL: env(ENV_CONFIG_ATTRIBUTES.MY_PAGES_URL),
    CUSTOMER_SERVICE_URL: env(ENV_CONFIG_ATTRIBUTES.CUSTOMER_SERVICE_URL),
    MAIN_PAGE_URL: env(ENV_CONFIG_ATTRIBUTES.MAIN_PAGE_URL),
    GET_STARTED_PAGE_URL: env(ENV_CONFIG_ATTRIBUTES.GET_STARTED_PAGE_URL),
    TERMS_PAGE_URL: env(ENV_CONFIG_ATTRIBUTES.TERMS_PAGE_URL),
    ABOUT_WIFI_PAGE_URL: env(ENV_CONFIG_ATTRIBUTES.ABOUT_WIFI_PAGE_URL),
    LANGUAGE: env(ENV_CONFIG_ATTRIBUTES.LANGUAGE),
    AUTH_CALLBACK_URL: env(ENV_CONFIG_ATTRIBUTES.AUTH_CALLBACK_URL),
    AUTH_URL: env(ENV_CONFIG_ATTRIBUTES.AUTH_URL),
    AUTH_SCOPE: env(ENV_CONFIG_ATTRIBUTES.AUTH_SCOPE),
    AUTH_CLIENT_ID: env(ENV_CONFIG_ATTRIBUTES.AUTH_CLIENT_ID),
    AUTH_TOKEN_URL: env(ENV_CONFIG_ATTRIBUTES.AUTH_TOKEN_URL),
    AUTH_THEME: env(ENV_CONFIG_ATTRIBUTES.AUTH_THEME),
    ENABLE_DATA_LAYERS: env(ENV_CONFIG_ATTRIBUTES.ENABLE_DATA_LAYERS).toLowerCase() === 'true',
};

export { config };
